import React, { FunctionComponent } from "react";
import { ICardElementWithChildren } from "backend/model/model";
import TextElement from "reportengine/TextElement";
import Report from "reportengine/Report";
import Slide from "reportengine/Slide";
import { createReport, saveBlob } from "reportengine/createReport";
import reportContextToRequest from "./reportContextToRequest";
import ProgressModal from "design/components/progress/ProgressModal";
import flattenHierarchy from "backend/flattenHierarchy";
import KPISlide from "./slides/KPISlide";
import InitiativeSlide from "./slides/InitiativeSlide";
import useElement from "backend/hooks/elements/useElement";
import useElements from "backend/hooks/elements/useElements";

const ConfigurableReport = (
  props: React.PropsWithChildren<{
    items: ICardElementWithChildren[];
    filetype: string;
    onClose?: () => void;
  }>
) => {
  const { filetype } = props;
  const [status, setStatus] = React.useState("Generating Report");
  const [progress, setProgres] = React.useState(0);
  const [blob, setBlob] = React.useState<null | Blob>(null);

  const { data: items } = useElements(props.items.map((item) => item.id));

  const kpis = React.useMemo(() => {
    return items ? items.filter((item) => item.typename === "KPI") : [];
  }, [items]);
  const initiatives = React.useMemo(() => {
    return items ? items.filter((item) => item.typename === "Initiative") : [];
  }, [items]);

  if (!items) {
    return null;
  }

  return (
    <div>
      <Report
        template="/templates/report_en.pptx"
        onNothingToRender={() => {
          setStatus("Nothing to render");
        }}
        onProgress={(value) => {
          setProgres(value);
          console.log("slide progress ", value);
        }}
        onReadyToRender={async (report) => {
          setProgres(95);
          const blob = await createReport(
            await reportContextToRequest(report, "PerformanceReport", filetype)
          );
          setBlob(blob);
          setProgres(100);
        }}
      >
        <Slide index={0}>
          <TextElement slideElement="subtitle">Configurable Report</TextElement>
          <TextElement slideElement="title">Performance Report</TextElement>
        </Slide>
        {kpis.map((kpi) => {
          return <KPISlide item={kpi} />;
        })}
        {initiatives.map((initiative) => {
          return <InitiativeSlide item={initiative} />;
        })}
      </Report>
      <ProgressModal
        isOpen
        onClose={() => {
          if (props.onClose) {
            props.onClose();
          }
        }}
        isComplete={!!blob}
        cancelClickHandler={props.onClose}
        completedClickHandler={() => {
          if (blob) {
            saveBlob(`CustomizedReport.${filetype}`, blob);
          }
        }}
        downloadText="Download"
        progress={progress}
        statusText={status}
      />
    </div>
  );
};

export default ConfigurableReport;
